var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'loader',
        { 'is-active': _vm.isActive }
    ]},_vm._l((4),function(i){return _c('span',{key:i})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }